module.exports = __webpack_public_path__ + "static/img/vr.25513ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homepage/vr.jpg
// module id = R7hH
// module chunks = 1